module.exports = __webpack_public_path__ + "media/images/icn-user-fade-4f79c42eda0cfcb7d50a3502859e23d9.png";